export const LoanActionsControlsTopLevelSlotTestIds = {
  MOBILE_LOAN_ACTIONS_BUTTON: 'loan-actions-controls.mobile-loan-actions-button',
};
